import React from 'react';

import Dropdown from 'components/cosmos/dropdown';
import { ReactComponent as ArrowLeft } from 'components/svg/icons/arrow-left.svg';
import { ReactComponent as CloseCosmos } from 'components/svg/icons/close-cosmos.svg';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './SchedulerHeader.scss';

const SchedulerHeader = ({
  closeDropdown,
  description,
  goToPrevious,
  title
}) => {
  return (
    <>
      <Dropdown.MenuHeader className="_p-5">
        <span className="scheduler-header _d-flex _justify-content-between _text-3 _text-gray-700">
          <span className="scheduler-header__title _d-flex _text-3 _text-gray-700">
            {goToPrevious && (
              <ArrowLeft
                data-test="arrow-left-icon"
                className="_mr-5 scheduler-header__title__icon"
                onClick={goToPrevious}
              />
            )}
            <I18n data-test="scheduler-header-title" label={title || ''} />
          </span>
          <CloseCosmos
            data-test="close-icon"
            className="scheduler-header__title__icon"
            onClick={closeDropdown}
          />
        </span>
      </Dropdown.MenuHeader>
      {description && (
        <p className="scheduler-header__description _text-2 _text-gray-500 _pr-5 _pl-5">
          <I18n
            data-test="scheduler-header-description"
            label={description || ''}
          />
        </p>
      )}
    </>
  );
};

SchedulerHeader.propTypes = {
  closeDropdown: PropTypes.func,
  description: PropTypes.string,
  goToPrevious: PropTypes.func,
  title: PropTypes.string
};

export default SchedulerHeader;
